module.exports = __webpack_public_path__ + "img/card.bdff9356.jpg";